import { forwardRef } from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';

const ReactRouterAdapter = forwardRef(({ Component, ...props }, ref) => {
  const location = useLocation();
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  return (
    <Component
      searchParams={searchParams}
      setSearchParams={setSearchParams}
      location={location}
      params={params}
      navigate={navigate}
      ref={ref}
      {...props}
    />
  );
});

export default ReactRouterAdapter;
